import { createRoute } from '@tanstack/react-router';
import { InvoiceDetailPage } from '@/features/invoices/invoice-detail-page.js';
import { authenticatedRoute } from './authenticated.js';

/**
 * `/commandes/factures/$id` — fiche d'une facture Pennylane (`02` §3).
 *
 * Sous `/commandes` parce que c'est là qu'on l'atteint : depuis la liste
 * unifiée, ou depuis un lien d'alerte. Déclarée **avant** `/commandes/$id`
 * dans `router.tsx` : sans cela, « factures » serait pris pour un id de
 * commande.
 */
export const invoiceDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/commandes/factures/$id',
  component: InvoiceDetailPage,
});
